export default __webpack_public_path__ + "static/media/tourly-book-no-bg.26501c1e.png";